import { useIntersectionObserver } from '@grandvisionhq/lib-utils-react';

const useWasSeenByUser = ()=>{
    const { isIntersecting , ref  } = useIntersectionObserver({
        threshold: 0.75,
        freezeOnceVisible: true
    });
    return {
        ref,
        wasSeen: isIntersecting
    };
};

export { useWasSeenByUser };
//# sourceMappingURL=use-was-seen-by-user.js.map
